import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import ScamTicker from "@/components/landing/ScamTicker";
import ScamOfWeek from "@/components/landing/ScamOfWeek";
import ScamArchive from "@/components/landing/ScamArchive";
import Stats from "@/components/landing/Stats";
import Services from "@/components/landing/Services";
import Community from "@/components/landing/Community";
import FeedGallery from "@/components/landing/FeedGallery";
import Connect from "@/components/landing/Connect";
import Footer from "@/components/landing/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, anchors: true, lerp: 0.1 });
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App min-h-screen bg-background text-foreground" data-testid="app-root">
      <div className="grain-overlay" aria-hidden="true" />
      <Toaster position="top-center" richColors />
      <Nav />
      <main>
        <Hero />
        <ScamTicker />
        <ScamOfWeek />
        <ScamArchive />
        <Stats />
        <Services />
        <Community />
        <FeedGallery />
        <Connect />
      </main>
      <Footer />
    </div>
  );
}

export default App;
